import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-styleguide-elements',
  templateUrl: './styleguide-elements.component.html',
  styleUrls: ['./styleguide-elements.component.scss']
})
export class StyleguideElementsComponent implements OnInit {

  examplePaginationList = [1,2,3,4,5];

  constructor() { }

  ngOnInit() {
  }

}
